<template>
  <div class="content">
    <div class="type-menu">
      <div class="type-checkbox">
        <el-checkbox-group v-model="checkedTypes">
          <el-checkbox
            name="type"
            v-for="item in typesParams"
            :key="'checkbox-' + item"
            :label="item"
            >{{ item.substring(0, 4) }}</el-checkbox
          >
        </el-checkbox-group>
      </div>
      <i
        class="el-icon-plus"
        @click="openTypesDialog()"
        style="font-size: 24px; cursor: pointer"
      ></i>
    </div>
    <div class="type-lengend">
      <div class="lengend">
        <div v-for="item in typeLengend" :key="item.text">
          <img :src="item.icon" width="16px" />
          {{ item.text }}
        </div>
      </div>
      <div class="info">
        <i class="el-icon-question"></i
        >图示中红色标识表示该种危废产生量超100吨（含）；黄色标识表示该危废产生量为10-100吨：蓝色标识表示该危废产生量为0-10吨
      </div>
    </div>
    <div :visible="true" :modal="false" :show-close="false" class="dialog-drag">
      <el-popover
        placement="top-start"
        trigger="click"
        popper-class="area-popper"
      >
        <div style="width: 350px">
          <dangerType-filter
            ref="dangerTypeFilter"
            :high-light="true"
            @change="fetchPoint"
          />
        </div>
        <div slot="reference" style="width: 35px; height: 35px">
          <i class="el-icon-search" style="font-size: 22px; color: #409eff" />
        </div>
      </el-popover>
    </div>
    <div id="map-container"></div>
    <div
      ref="infoData"
      v-show="isShowInfo"
      class="custom-info input-card content-window-card"
    >
      <div class="content-window-card" ref="infoData" v-show="isShowInfo">
        <img
          src="@/assets/newImages/eventx.png"
          style="
            height: 20px;
            width: 45px;
            cursor: pointer;
            position: absolute;
            right: 10px;
            top: 8px;
            z-index: 9;
          "
          @click="closeInfoWindow()"
        />
      </div>
      <div class="info-middle">
        <div style="margin: 15px 0px; position: relative">
          <div class="popup-row">
            <div class="popup-row-label">企业名称：</div>
            <div class="popup-row-value">{{ companyInfo.companyName }}</div>
          </div>
          <!-- <div class="popup-row">
            <div class="popup-row-label">危废产生量：</div>
          </div> -->
          <div
            class="popup-row"
            v-for="{ type, outPut } in companyInfo.types"
            :key="type"
          >
            <div class="popup-row-label">{{ type }} ：</div>
            <div class="popup-row-value">{{ outPut }} 吨</div>
          </div>
        </div>
      </div>
      <div
        style="
          margin: 0 auto;
          width: 40px;
          height: 20px;
          bottom: -18px;
          position: relative;
          overflow: hidden;
        "
      >
        <div class="tdt-infowindow-tip"></div>
      </div>
    </div>
    <!-- <div class="info-top">
        <div>
          <span>{{ companyInfo.companyName }}</span>
        </div>
        <img
          @click="closeInfoWindow"
          src="https://webapi.amap.com/images/close2.gif"
        />
      </div>
      <div class="info-middle" style="background-color: white">
        <div>危废产生量：</div>
        <div v-for="{ type, outPut } in companyInfo.types" :key="type">
          <span>{{ type }}：</span>
          <span>{{ outPut }} 吨</span>
        </div>
      </div>
      <div
        class="info-bottom"
        style="position: relative; top: 0px; margin: 0px auto"
      >
        <img src="https://webapi.amap.com/images/sharp.png" />
      </div> -->

    <el-dialog
      width="700px"
      title="更换显示危废种类"
      :visible.sync="dialogVisible"
    >
      <div class="dialog-form">
        <el-transfer
          :titles="['全部种类', '已选择种类']"
          v-model="transTypes"
          :data="types"
        ></el-transfer>
      </div>

      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="saveTypes()">确 定</el-button>
      </div>
    </el-dialog>
    <!-- <div class="info">
      点击地图上的点标记，打开所添加的自定义信息窗体
    </div> -->
  </div>
</template>
<script>
import dangerTypeFilter from "./components/dangerTypeFilter";

import icon1 from "@/assets/markers/dangerType/typeIcon-1.svg";
import icon2 from "@/assets/markers/dangerType/typeIcon-2.svg";
import icon3 from "@/assets/markers/dangerType/typeIcon-3.svg";
import icon4 from "@/assets/markers/dangerType/typeIcon-4.svg";
import icon5 from "@/assets/markers/dangerType/typeIcon-5.svg";

export default {
  data() {
    return {
      dialogVisible: false,
      isShowInfo: false,
      companyInfo: {},
      typeLengend: [
        {
          text: "一个种类",
          icon: icon1,
        },
        {
          text: "二个种类",
          icon: icon2,
        },
        {
          text: "三个种类",
          icon: icon3,
        },
        {
          text: "四个种类",
          icon: icon4,
        },
        {
          text: "五种及以上",
          icon: icon5,
        },
      ],
      typesParams: [
        "HW02医药废物",
        "HW03废药物、药品",
        "HW01医疗废物2",
        "HW49其他废物",
      ],
      // numTotal: 5, //
      checkedTypes: [
        "HW02医药废物",
        "HW03废药物、药品",
        "HW01医疗废物2",
        "HW49其他废物",
      ],
      transTypes: [],
      params: {},
      map: null,
      mapData: [],
      markers: [],
      types: [],
      geo: null,
    };
  },
  computed: {
    searchParams() {
      let { date, ...params } = this.params;
      if (date && date.length > 0) {
        return { startDate: date[0], endDate: date[1], ...params };
      }
      return { ...params };
    },
  },
  components: {
    dangerTypeFilter,
  },
  watch: {
    checkedTypes: {
      handler(val) {
        this.fetchPoint();
      },
      deep: true,
      // immediate: false
    },
  },
  mounted() {
    // this.getData();
    this.getTypes();
    this.createMap();
  },
  created() {},
  methods: {
    saveTypes() {
      if (!this.transTypes || this.transTypes.length <= 0) {
        this.$message({
          message: "请选择危废种类",
          type: "warning",
        });
        return;
      }
      this.typesParams = this.transTypes;
      // this.checkedTypes = this.checkedTypes.filter(t => {
      //   return this.typesParams.includes(t);
      // })
      this.checkedTypes = this.transTypes;

      this.dialogVisible = false;
    },
    openTypesDialog() {
      this.transTypes = this.typesParams;
      this.dialogVisible = true;
    },
    getTypes() {
      let url = this.$api.dangerWasters.getTypes;
      this.$axios.get(url, false).then((res) => {
        if (res.data.code == 0) {
          this.types = res.data.data.types.map((t) => {
            return { key: t.name, label: t.name, disabled: false };
          });
        } else {
          this.$message({
            message: "加载数据失败，请重试",
            type: "error",
          });
        }
      });
    },

    fetchPoint(params) {
      if (params) this.params = params;

      const types = this.checkedTypes.join("-");

      const searchParams = { ...this.searchParams, types };

      let url = this.$api.map.getDangerWasterTypeMapData;
      this.$axios.get(url, searchParams, false).then((res) => {
        if (res.data.code == 0) {
          this.mapData = res.data.data;
          // this.map.clearMap()

          this.map.remove(this.markers);
          this.addMarker();
          this.clearGeoJson();
          if (searchParams.jurisdiction) {
            this.addGeoJson(searchParams.jurisdiction, "#bfa");
          }
        } else {
          this.$message({
            message: "加载数据失败，请重试",
            type: "error",
          });
        }
      });
    },

    //1.创建map对象
    createMap() {
      //1.地图初始化时，在地图上添加marker标记,鼠标点击marker可弹出自定义的信息窗体
      this.map = new AMap.Map("map-container", {
        resizeEnable: true,
        animateEnable: false,
        mapStyle: "amap://styles/darkblue",
        // mapStyle: "amap://styles/d88864bb17a5b8d0267b5e0f899e293c",
        // // showLabel: false,
        // features: ['bg', 'road', 'building'],
        center: [116.29920714, 39.681], //初始地图的中心点坐标
        zoom: 14.6,
      });
      this.addGeoJson("all", "#2e9194", true);
      // this.addGeoJson("二期", "red");
      // this.addGeoJson("三期", "green");
    },
    addGeoJson(jsonName, color, isAll) {
      let geoJSON = require(`@/assets/geojson/${jsonName}.json`);
      // let geoJSON = require(jsonName);

      let geojson = new AMap.GeoJSON({
        geoJSON: geoJSON,
        // 还可以自定义getMarker和getPolyline
        getPolygon: function (geojson, lnglats) {
          // 计算面积
          return new AMap.Polygon({
            path: lnglats,
            fillOpacity: 0.1, // 面积越大透明度越高
            strokeColor: color,
            fillColor: color,
          });
        },
      });
      if (!isAll) this.geo = geojson;

      this.map.add(geojson);
    },
    clearGeoJson() {
      if (this.geo) this.map.remove(this.geo);
    },
    //2.添加点标记
    addMarker() {
      const self = this;

      let arr = [];
      this.isShowInfo = false;
      this.map.remove(this.markers);
      this.markers = [];

      this.mapData.forEach((item) => {
        const sum = item.types.reduce(
          (accumulator, current) => accumulator + current.outPut,
          0
        );
        let color = "red";
        if (sum <= 10) {
          color = "blue";
        } else if (sum <= 100) {
          color = "yellow";
        }

        let { length } = item.types;
        if (length == 0) return true;

        if (length > 5) length = 5;
        let fileName = `typeIcon-${length}-${color}.svg`;

        const icon = new AMap.Icon({
          // content: "重点",
          // size: new AMap.Size(33, 35), // 图标尺寸
          image: require("@/assets/markers/dangerType/" + fileName), // Icon的图像
          // imageOffset: new AMap.Pixel(0, -60), // 图像相对展示区域的偏移量，适于雪碧图等
          imageSize: new AMap.Size(24, 35), // 根据所设置的大小拉伸或压缩图片
        });

        const position = [item.lng, item.lat];

        let marker = new AMap.Marker({
          icon, //点标记图片路径
          position, //位置
          anchor: "bottom-center",
        });
        arr.push(
          Object.assign(item, {
            mapId: marker._amap_id,
          })
        );

        marker.setMap(self.map);
        marker.on("click", (e) => {
          self.markerClick(arr, marker);
        });
        this.markers.push(marker);
        // AMap.event.addListener(marker, 'click', (e) => {
        //   self.markerClick(arr, marker)
        // })
      });

      // 创建AMap.MarkerClusterer的实例
      // const markerClusterer = new AMap.MarkerClusterer(this.map, positions);
    },
    //3.点击标记 获取所点击标记的信息以及窗体要展示的数据，创建信息窗体
    markerClick(arr, marker) {
      let arrNew = arr.filter((x) => x.mapId == marker._amap_id);
      this.companyInfo = arrNew && arrNew[0];
      let infoWindow = this.createInfoWindow();
      this.openInfoWindow(infoWindow, marker);
    },
    //4.构建自定义窗体
    createInfoWindow() {
      let infoWindowData = new AMap.InfoWindow({
        isCustom: true, //使用自定义窗体
        content: this.$refs.infoData,
        // content: this.getContent(),
        anchor: "bottom-center",
        offset: new AMap.Pixel(0, -40),
      });
      return infoWindowData;
    },

    //5.打开窗体
    openInfoWindow(infoWindow, marker) {
      this.isShowInfo = true;
      this.$nextTick(() => {
        infoWindow.open(this.map, marker.getPosition());
      });
    },
    //6.关闭窗体
    closeInfoWindow() {
      this.isShowInfo = false;
      this.map.clearInfoWindow();
    },
  },
};
</script>

<style lang="scss" scoped>
html,
body,
#map-container {
  height: 100%;
  width: 100%;
}
.popup-row {
  width: 350px;
  // width: 100%;
  padding: 4px 10px;
  font-size: 13px;
  display: flex;
  &::after {
    clear: both;
    content: "";
    display: block;
  }

  .popup-row-label {
    width: 150px;
    // display: inline-block;
    color: #7dc3f6;
    text-align: right;
    font-size: 14px;
  }

  .popup-row-value {
    flex: 1;
    // width: 200px;
    // overflow: hidden;
    // text-overflow: ellipsis;
    // white-space: nowrap;
    // display: block;
    // margin-left: 100px;
    color: #d7d7d7;
    font-size: 14px;
  }
}
/deep/ .amap-info {
  background: url("../../assets/newImages/infoWindow.png") no-repeat 100% 100%;
  background-size: 100% 100%;
  // color: #024287;
}
/deep/ .tdt-container a.tdt-infowindow-close-button {
  color: transparent;
  background: url("../../assets/newImages/eventx.png") no-repeat;
  background-size: 100% 100%;
  width: 40px;
  height: 20px;
}
/deep/ .tdt-infowindow-tip {
  width: 17px;
  height: 17px;
  padding: 1px;
  margin: -10px auto 0;
  -webkit-transform: rotate(45deg);
  -moz-transform: rotate(45deg);
  -ms-transform: rotate(45deg);
  -o-transform: rotate(45deg);
  transform: rotate(45deg);
  background: #094a92;
}
.content {
  position: relative;
  height: 100%;
  width: 100%;
}

.el-checkbox {
  color: #ffffff;
}

/deep/.el-checkbox__input.is-checked + .el-checkbox__label {
  color: #409eff !important;
}

.type-lengend {
  position: absolute;
  left: 10px;
  bottom: 10px;

  z-index: 1;

  .lengend {
    display: flex;
    color: #fff;

    > div {
      margin-right: 16px;
    }
  }

  .info {
    margin-top: 10px;
    color: yellow;
  }
}

.type-menu {
  width: 90%;
  display: flex;
  position: absolute;
  top: 20px;
  left: 10px;
  z-index: 1;
  color: #fff;

  .type-checkbox {
    max-width: calc(100% - 16px);
    margin-right: 16px;
    line-height: 24px;
  }
}

.dialog-drag {
  position: absolute;
  top: 20px;
  right: 25px;
  z-index: 99;
  width: 240px;
  width: 35px;
  //height: 400px;
  //background-color: #ffffff;
  //padding: 15px;
  //border: 1px solid #e3e3e8;
  border-radius: 4px;
}

.content-window-card {
  // position: relative;
  // box-shadow: none;
  bottom: 0;
  left: 0;
  /* width: auto; */
  width: 350px;
  padding: 0;
}

.content-window-card p {
  height: 2rem;
}

// .custom-info {
//   border: solid 1px silver;
// }

div.info-top {
  position: relative;
  background: none repeat scroll 0 0 #f9f9f9;
  border-bottom: 1px solid #ccc;
  border-radius: 5px 5px 0 0;
}

div.info-top div {
  display: inline-block;
  color: #333333;
  font-size: 14px;
  font-weight: bold;
  line-height: 31px;
  padding: 0 10px;
}

div.info-top img {
  position: absolute;
  top: 10px;
  right: 10px;
  transition-duration: 0.25s;
}

div.info-top img:hover {
  box-shadow: 0px 0px 5px #000;
}

div.info-middle {
  font-size: 12px;
  padding: 10px 6px;
  line-height: 20px;
}

div.info-bottom {
  height: 0px;
  width: 100%;
  clear: both;
  text-align: center;
}

div.info-bottom img {
  position: relative;
  z-index: 104;
}

/* span {
  margin-left: 5px;
  font-size: 11px;
} */

.info-middle img {
  float: left;
  margin-right: 6px;
}

.info-span {
  /* margin-left: 35px; */
  font-size: 11px;
}

.info-div {
  width: 140px;
  display: inline-block;
  margin-left: 10px;
}

.info-img {
  width: 40px;
  height: 40px;
}

.info-a-title {
  /* color: #000000; */
  font-size: 16px;
}

#map-container {
  height: 100%; //820px;
}

#map-container .amap-icon img,
.amap-marker-content img {
  width: 64px;
  height: 64px;
}
</style>